import * as actionTypes from "../actionTypes";
import Axios from "../../../services/NetworkService";

export const hdcInit = () => {
  return {
    type: actionTypes.HDC_INIT,
  };
};

export const hdcSuccess = (data) => {
  return {
    type: actionTypes.HDC_SUCCESS,
    data: data,
  };
};

export const hdcFail = (error) => {
  return {
    type: actionTypes.HDC_FAIL,
    error: error,
  };
};

export const hdc = (query) => {
  let urlEndPoint = "/hdc";
  const queries = [];

  if (typeof query === "object") {
    Object.keys(query).forEach((k) => {
      queries.push(`${k}=${query[k]}`);
    });
  }

  if (queries.length > 0) {
    urlEndPoint += `?${queries.join("&")}`;
  }

  console.log('[HDC Debug] Fetching data from endpoint:', urlEndPoint);

  return async (dispatch) => {
    dispatch(hdcInit());
    try {
      // First get the sensor metadata
      const metadataResponse = await Axios.get(urlEndPoint, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      console.log('[HDC Debug] Metadata Response:', {
        status: metadataResponse.status,
        data: metadataResponse.data,
        sensors: metadataResponse.data.data?.length || 0
      });

      const sensors = metadataResponse.data.data || [];

      // Then fetch the measurement data for each sensor
      const now = new Date();
      const oneHourAgo = new Date(now.getTime() - 60 * 60 * 1000);

      const sensorsWithData = await Promise.all(sensors.map(async (sensor) => {
        try {
          const measurementResponse = await Axios.post("/hdcdata", {
            start: oneHourAgo.toISOString(),
            end: now.toISOString(),
            deviceIds: [sensor._id],
            resolution: 60,
          });

          console.log(`[HDC Debug] Measurement data for sensor ${sensor.name}:`, measurementResponse.data);

          return {
            ...sensor,
            data: measurementResponse.data.data[sensor._id] || []
          };
        } catch (error) {
          console.error(`[HDC Debug] Error fetching measurements for sensor ${sensor.name}:`, error);
          return sensor;
        }
      }));

      dispatch(hdcSuccess(sensorsWithData));
    } catch (error) {
      console.error('[HDC Debug] API Error:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      dispatch(hdcFail(error));
    }
  };
};
